// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
export class PVI extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Positive Volume Index';
        this.SetIndicatorLine('PVI', Color.Blue, 1, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        // Input parameter
        this.SourcePrice = PriceType.Close;
        super.InputParameter(new InputParameterCombobox('SourcePrice', 'Sources prices for MA', 1, [
            { Close: PriceType.Close },
            { Open: PriceType.Open },
            { High: PriceType.High },
            { Low: PriceType.Low },
            { Typical: PriceType.Typical },
            { Medium: PriceType.Medium },
            { Weighted: PriceType.Weighted }
        ]));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'PVI';
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count - 1 < 1) {
            this.SetValue(0, 1);
            return;
        }
        let curVolume = 0;
        let prevVolume = 0;
        curVolume = this.CurrentData.Volume();
        prevVolume = this.CurrentData.Volume(1);
        const prevPVI = this.GetValue(0, 1);
        if (curVolume > prevVolume) {
            const curPrice = this.CurrentData.getPriceByType(this.SourcePrice);
            const prevPrice = this.CurrentData.getPriceByType(this.SourcePrice, 1);
            const curPVI = prevPVI + (prevPVI * (curPrice - prevPrice)) / prevPrice;
            this.SetValue(0, curPVI);
        }
        else {
            this.SetValue(0, prevPVI);
        }
    }
}
